import { GeneratedProductReleaseType } from '../../../types/generated';

export const resolveReleaseType = (
  releaseType?: GeneratedProductReleaseType | null,
) => {
  return {
    isBuy:
      releaseType === GeneratedProductReleaseType.Public ||
      releaseType === GeneratedProductReleaseType.Private ||
      releaseType === GeneratedProductReleaseType.Timed,
    isDraw: releaseType === GeneratedProductReleaseType.Draw,
  };
};
